import { useEffect, useLayoutEffect, useRef, useState } from 'react';

// MENU NGỮ CẢNH cho 1 hội thoại trong danh sách (kiểu Zalo):
//  - Web: mở bằng CHUỘT PHẢI -> popup nổi tại con trỏ.
//  - Mobile/app: mở bằng GIỮ (long-press) -> bảng trượt từ đáy (bottom-sheet).
// `menu` = { target, x, y, sheet }. `target` = { id, ids, kind, pinned, muted, unread, name }.
export default function ConvMenu({ menu, onClose, onPin, onUnread, onMute, onHide }) {
  const popRef = useRef(null);
  const [pos, setPos] = useState({ left: menu.x, top: menu.y });

  // Popup web: kẹp trong màn hình (không tràn phải/dưới).
  useLayoutEffect(() => {
    if (menu.sheet) return;
    const el = popRef.current;
    if (!el) return;
    const w = el.offsetWidth;
    const h = el.offsetHeight;
    const pad = 8;
    let left = menu.x;
    let top = menu.y;
    if (left + w + pad > window.innerWidth) left = window.innerWidth - w - pad;
    if (top + h + pad > window.innerHeight) top = window.innerHeight - h - pad;
    setPos({ left: Math.max(pad, left), top: Math.max(pad, top) });
  }, [menu]);

  useEffect(() => {
    const onKey = (e) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  const t = menu.target;
  const items = [
    { ic: '📌', label: t.pinned ? 'Bỏ ghim hội thoại' : 'Ghim hội thoại', on: () => { onClose(); onPin(t); } },
    { ic: '💬', label: t.unread > 0 ? 'Đánh dấu đã đọc' : 'Đánh dấu chưa đọc', on: () => { onClose(); onUnread(t); } },
    { ic: '🔕', label: t.muted ? 'Bật thông báo' : 'Tắt thông báo', on: () => { onClose(); onMute(t); } },
    { ic: '🗑️', label: 'Xóa hội thoại', danger: true, on: () => { onClose(); onHide(t); } },
  ];

  const rows = items.map((it, i) => (
    <button key={i} type="button" className={'convmenu-item' + (it.danger ? ' danger' : '')} onClick={it.on}>
      <span className="convmenu-ic" aria-hidden="true">{it.ic}</span>
      <span>{it.label}</span>
    </button>
  ));

  if (menu.sheet) {
    return (
      <div className="convmenu-backdrop sheet" onClick={onClose}>
        <div className="convmenu-sheet" onClick={(e) => e.stopPropagation()}>
          {t.name ? <div className="convmenu-sheet-title">{t.name}</div> : null}
          {rows}
          <button type="button" className="convmenu-item convmenu-cancel" onClick={onClose}>Hủy</button>
        </div>
      </div>
    );
  }
  return (
    <div className="convmenu-backdrop" onClick={onClose} onContextMenu={(e) => { e.preventDefault(); onClose(); }}>
      <div ref={popRef} className="convmenu-pop" style={{ left: pos.left, top: pos.top }} onClick={(e) => e.stopPropagation()}>
        {rows}
      </div>
    </div>
  );
}
